import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import ordersService from "@/services/orders.js";

interface CreateOrderLineItemArgs {
  orderId: string;
  payload: {
    new_product_id: string;
    status: string;
    product_type: string;
  };
}

export const useCreateOrderLineItem = (
  useMutationOptions?: UseMutationOptions<AxiosResponse, Error, CreateOrderLineItemArgs>,
) => {
  return useMutation<AxiosResponse, Error, CreateOrderLineItemArgs>({
    mutationFn: ({ orderId, payload }) => ordersService.createOrderLineItem({ orderId, payload }),
    ...useMutationOptions,
  });
};
